import * as v from 'valibot';

const contentSchema = v.object({
  id: v.number(),
  type: v.string(),
  text: v.string(),
  postProcessed: v.boolean(),
  attributesRemoved: v.boolean(),
  renamed: v.boolean(),
  attributes: v.nullish(v.any()),
  children: v.any(),
});

const authorSchema = v.object({
  name: v.string(),
  avatar: v.string(),
  url: v.string(),
  profile: v.string(),
  about: v.nullish(v.string()),
  expertise: v.nullish(v.array(contentSchema)),
  integer_id: v.nullish(v.string()),
  telegram: v.nullish(v.string()),
  vkontakte: v.nullish(v.string()),
  twitter: v.nullish(v.string()),
});

const imgSchema = v.object({
  url: v.string(),
  width: v.number(),
  height: v.number(),
});

const tagSchema = v.object({
  id: v.number(),
  slug: v.string(),
  url: v.string(),
  title: v.string(),
});

const metaSchema = v.object({
  promo: v.nullish(v.string()),
  advert: v.nullish(v.string()),
  main_color: v.nullish(v.string()),
  cover_source: v.nullish(v.string()),
  cover_source_url: v.nullish(v.string()),
  post_source: v.nullish(v.string()),
  post_source_url: v.nullish(v.string()),
  ads_source: v.string(),
  ads_source_url: v.string(),
  authors: v.nullish(v.string()),
});

const seoSchema = v.object({
  title: v.string(),
  description: v.string(),
  robots: v.string(),
  canonical: v.string(),
  og_image: v.string(),
  site_icon: v.string(),
  schema: v.string(),
});

export const baseArticleScheme = v.object({
  id: v.number(),
  title: v.string(),
  name: v.string(),
  type: v.string(),
  url: v.string(),
  date: v.number(),
  teaser_url: v.string(),
  teaser_target: v.string(),
  excerpt: v.string(),
  author: authorSchema,
  categories: v.array(
    v.object({
      id: v.number(),
      title: v.string(),
      slug: v.string(),
      url: v.string(),
      color: v.string(),
      icon: v.nullish(v.string()),
      covers: v.array(imgSchema),
      description: v.nullish(v.string()),
      parsed_description: v.array(contentSchema),
      og_image: v.nullish(v.string()),
    }),
  ),
  tags: v.array(tagSchema),
  is_advertising: v.boolean(),
  is_promo: v.boolean(),
  img: v.array(v.optional(imgSchema)),
  image: v.nullish(
    v.object({
      image_id: v.number(),
      alt: v.string(),
      sizes: v.array(imgSchema),
      origin: imgSchema,
    }),
  ),
  default_img: v.array(imgSchema),
  comments_enabled: v.boolean(),
  comments_count: v.number(),
  reactions_enabled: v.boolean(),
  views: v.number(),
  ab_titles_data: v.array(v.string()),
  advert_label: v.string(),
  test_pixels: v.array(v.string()),
  ads_token: v.nullish(v.string()),
});

export const singlePostSchema = v.object({
  item: v.object({
    ...baseArticleScheme.entries,
    template: v.string(),
    meta: metaSchema,
    parsed_content: v.array(contentSchema),
  }),
  meta: v.object({
    total_items: v.number(),
    total_pages: v.number(),
    limit: v.number(),
    current_page: v.number(),
    is_user_logged_in: v.boolean(),
  }),
  seo: seoSchema,
  adfox_params: v.object({
    lh_adfox_terms: v.string(),
    lh_adfox_tags: v.string(),
    lh_adfox_streams: v.string(),
    lh_adfox_noad: v.string(),
    lh_adfox_noadsense: v.number(),
    lh_adfox_postid: v.number(),
    lh_adfox_pk: v.string(),
    lh_adfox_homepage: v.boolean(),
  }),
});
